<template>
	<transition name="dropdown_list-wrap">
		<div
			v-if="isOpen"
			class="dropdown_list-wrap"
			:class="[isEnoughBottomIndent ? 'dropdown_list-wrap--bottom' : 'dropdown_list-wrap--top']"
			ref="wrap"
		>
			<slot />
		</div>
	</transition>
</template>

<script>
import {SIDE_MARGIN} from './dd-constants.js';
export default {
	name: 'DropdownCustomPositionTop',
	props: {
		isOpen: {
			type: Boolean,
			default: false,
		},
		windowSize: {
			type: Object,
			default: null,
		},
		openerDom: {
			type: [Object, HTMLButtonElement],
			default: null,
		},
	},
	data() {
		return {
			isEnoughBottomIndent: true,
		};
	},
	watch: {
		windowSize() {
			this.calcPosition();
		},
		isOpen() {
			this.calcPosition();
		},
	},
	methods: {
		calcPosition() {
			if (!this.isOpen || !this.openerDom) return;
			this.$nextTick(() => {
				const clientHeight = this.windowSize?.height || document.body.clientHeight;
				const openerElement = this.openerDom?.$el ?? this.openerDom;
				const {bottom} = openerElement.getBoundingClientRect();
				this.isEnoughBottomIndent = bottom < clientHeight * 0.6 - SIDE_MARGIN / 2;
			});
		},
	},
};
</script>

<style scoped lang="scss">
.dropdown_list-wrap {
	position: absolute;
	z-index: 10000;
	left: 0;
	width: 100%;
	display: block !important;

	::v-deep {
		ul {
			position: static !important;
		}
	}
}
.dropdown_list-wrap--top {
	transform-origin: bottom;
	bottom: calc(100% + 8px);
}
.dropdown_list-wrap--bottom {
	transform-origin: top;
	top: 100%;
}
.dropdown_list-wrap-enter-active,
.dropdown_list-wrap-leave-active {
	transition: transform 0.3s;
	transform: rotateX(0);
}
.dropdown_list-wrap-enter,
.dropdown_list-wrap-leave-to {
	transition: transform 0.3s;
	transform: rotateX(90deg);
}
</style>
